import {useState, useEffect} from 'react';
import QAapprovalAPI from './QaapprovalAPI';
import QAworkspace from './QAworkspace';

export default function QaapprovalActionImpl(){

    return (
        <>
        {/* <QAapprovalAPI/> */}
        <QAworkspace/>
        </>
    )
}